module.exports = __webpack_public_path__ + "static/img/0401_06.380ae39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0401_06.png
// module id = +TD9
// module chunks = 1